// config/industries.js
import financeImg from "assets/industries/finance.jpg";
import healthcareIcon from "assets/industries/healthcare.jpg";
import ecommerceIcon from "assets/industries/ecom.jpg";
import educationIcon from "assets/industries/education.jpg";
import logisticsIcon from "assets/industries/logistics.jpg";
import realestateIcon from "assets/industries/realestate.jpg";
import cyberIcon from "assets/industries/cyber-security.jpg";
import startIcon from "assets/industries/startups.jpg";

const industries = [
  { name: "Finance", icon: financeImg },
  { name: "Healthcare", icon: healthcareIcon },
  { name: "E-commerce", icon: ecommerceIcon },
  { name: "Education", icon: educationIcon },
  { name: "Logistics", icon: logisticsIcon },
  { name: "Real Estate", icon: realestateIcon },
  { name: "CyberSecurity", icon: cyberIcon },
  { name: "Startups Consulation", icon: startIcon },
];
export default industries;
